<template>
  <appQuoteEdit :propsMode="'edit'" quoteType="quote"></appQuoteEdit>
</template>
<script>
import appQuoteEdit from '../../../components/quote/quoteEdit.vue'

export default {
  name: 'quoteEdit',
  components: {
    appQuoteEdit
  }
}
</script>